<template>
  <VcFAQ />
</template>
